module.exports = __webpack_public_path__ + "img/yq6.a845776a.png";